export const buildTupleString = (name: string, value: string): string => `('${name}','${value}')`;
